import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";

import type { FieldItemProps } from "../types";

export function FieldItem({ fieldType, onAddField }: FieldItemProps) {
	const t = useTranslations("fields");
	const IconComponent = fieldType.icon;
	return (
		<Button
			aria-label={t("addFieldAria", { label: t(`types.${fieldType.type}.label`) })}
			className="group h-auto min-h-11 w-full justify-start p-4 text-left"
			onClick={() => onAddField(fieldType.type)}
			onKeyDown={(e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					onAddField(fieldType.type);
				}
			}}
			variant="outline"
		>
			<div className="flex w-full items-center gap-3">
				<div className="flex flex-shrink-0 items-center justify-center rounded-lg bg-primary/10 p-2 group-hover:bg-primary/20">
					<IconComponent aria-hidden="true" className="size-4 text-primary" />
				</div>
				<div className="flex min-w-0 flex-1 flex-col gap-1">
					<div className="flex items-center gap-2">
						<h3 className="text-wrap font-medium text-foreground text-sm">
							{t(`types.${fieldType.type}.label`)}
						</h3>
					</div>
					<p className="text-wrap text-muted-foreground text-xs">
						{t(`types.${fieldType.type}.description`)}
					</p>
				</div>
			</div>
		</Button>
	);
}
